import React from "react";
import "./arrow.css";

const Arrow = () => {
    return (
        <div class="arrow">
            <span></span>
            <span></span>
            <span></span>
        </div>
    );
};

export default Arrow;